export enum EstadoDocumentoFormato1 {
  GENERADO = 'GENERADO',
  FIRMADO_POR_SOLICITANTE = 'FIRMADO_POR_SOLICITANTE',
  FIRMADO_POR_COORDINADOR_DE_PROGRAMA = 'FIRMADO_POR_COORDINADOR_DE_PROGRAMA',
  FIRMADO_POR_COORDINADOR_DE_INSTITUCION = 'FIRMADO_POR_COORDINADOR_DE_INSTITUCION',
  FIRMADO = 'FIRMADO',
  CANCELADO = 'CANCELADO',
}

export interface IPersonalFirmaSnpDTO {
  cvu?: string;
  nombre?: string;
  ordenDeFirma?: number;
  firmado?: boolean;
  tituloFirma?: string;
  fechaFirma?: string;
}

export class PersonalFirmaSnpDTO implements IPersonalFirmaSnpDTO {
  constructor(
    public cvu?: string,
    public nombre?: string,
    public ordenDeFirma?: number,
    public firmado?: boolean,
    public tituloFirma?: string,
    public fechaFirma?: string
  ) {}

  static fromObject(item: IPersonalFirmaSnpDTO): PersonalFirmaSnpDTO {
    const opcion = new PersonalFirmaSnpDTO();
    for (const [key, value] of Object.entries(item)) {
      opcion[key] = value;
    }
    return opcion;
  }
}

export interface IFirmaFormato1 {
  fechaFirma?: string;
  urlDocumento?: string;
}

export class FirmaFormato1 implements IFirmaFormato1 {
  constructor(public fechaFirma?: string, public urlDocumento?: string) {}
}
